import type { JoinableSitesDataProvider } from '../../cross-join/providers/joinable-sites-data-provider';
import type { CustomizeLinks, GenericShowFlag } from '../../types';
import type { GenericSwitcherProps } from '../../ui/components/generic-switcher';
import {
	loadAtlassianSwitcher,
	loadJiraSwitcher,
	loadConfluenceSwitcher,
	loadGenericSwitcher,
} from '../../ui/components/loaders';
import { fg } from '@atlaskit/platform-feature-flags';

export default (product?: string): Promise<(props: GenericSwitcherProps) => React.JSX.Element> | Promise<(props: {
    cloudId: string;
    customizeLinks?: CustomizeLinks;
    joinableSitesDataProvider?: JoinableSitesDataProvider;
    product?: string;
    showFlag?: GenericShowFlag<any>;
}) => React.JSX.Element> => {
	loadAtlassianSwitcher();

	if (fg('navx-4453-jira-confluence-use-generic-switcher')) {
		return loadGenericSwitcher();
	}

	if (product === 'jira') {
		return loadJiraSwitcher();
	}

	if (product === 'confluence') {
		return loadConfluenceSwitcher();
	}

	return loadGenericSwitcher();
};
